var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMeusPedidos = function SvgMeusPedidos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.501,
    height: 30.501,
    viewBox: "0 0 8.07 8.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "b",
    markerHeight: 1.155,
    markerWidth: 0.324,
    orient: "auto-start-reverse",
    preserveAspectRatio: "none",
    refX: 0,
    refY: 0,
    style: {
      overflow: "visible"
    },
    viewBox: "0 0 5.324 6.155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.77 0-8.65 5V-5Z",
    style: {
      fill: "context-stroke",
      fillRule: "evenodd",
      stroke: "context-stroke",
      strokeWidth: "1pt"
    },
    transform: "scale(.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.647 12.866h12.446v10.608H16.647z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124.016 94.742a3.917 3.917 0 0 1-3.917 3.916 3.917 3.917 0 0 1-3.917-3.916 3.917 3.917 0 0 1 3.917-3.917 3.917 3.917 0 0 1 3.917 3.917z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.206879,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.444 4.169.56.318-.496.327-.61-.335Z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.981573,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(7.785 -1.135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.906 3.632.563.316-1.424.839-.59-.34Zm.786.464.63.334-1.435.827-.59-.34Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: ".0410666px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(2.406 -1.135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.931 5.343 1.456-.832-.024 1.664-1.42.849Zm-.088 0-1.426-.814.024 1.622L2.86 7Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".0410666px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(2.406 -1.135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.03 4.856.203.115.002.448-.032-.056-.023.042-.024-.054-.032.043-.017-.054-.039.041-.017-.062-.028.058.005-.53",
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.00155212,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(2.406 -1.135)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "5.33333px",
      lineHeight: 0.65,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline"
    },
    transform: "translate(.292 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.057 14.227 3.466 1.728v.176l-.384-.176h-3.082zm0-.373 3.466 1.728v.187l-3.466-1.728zm0-.39 3.466 1.74v.191l-3.466-1.744zm0-.373 3.466 1.739v.187l-3.466-1.739zm0-.362 3.466 1.728v.186l-3.466-1.738zm0-.379 1.648.827v-.827h1.818v1.91l-3.466-1.723z",
    "aria-label": "N",
    style: {
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal",
      fill: "green"
    },
    transform: "matrix(.28091 -.17362 0 .28091 -.607 4.684)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-2.444 4.169.56.318-.496.327-.61-.335Z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.981573,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(5.81 -.223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.906 3.632.563.316-1.424.839-.59-.34Zm.786.464.63.334-1.435.827-.59-.34Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: ".0410666px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(.431 -.223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.931 5.343 1.456-.832-.024 1.664-1.42.849Zm-.088 0-1.426-.814.024 1.622L2.86 7Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".0410666px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(.431 -.223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.03 4.856.203.115.002.448-.032-.056-.023.042-.024-.054-.032.043-.017-.054-.039.041-.017-.062-.028.058.005-.53",
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.00155212,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(.431 -.223)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "5.33333px",
      lineHeight: 0.65,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline"
    },
    transform: "translate(.292 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.057 14.227 3.466 1.728v.176l-.384-.176h-3.082zm0-.373 3.466 1.728v.187l-3.466-1.728zm0-.39 3.466 1.74v.191l-3.466-1.744zm0-.373 3.466 1.739v.187l-3.466-1.739zm0-.362 3.466 1.728v.186l-3.466-1.738zm0-.379 1.648.827v-.827h1.818v1.91l-3.466-1.723z",
    "aria-label": "N",
    style: {
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal",
      fill: "green"
    },
    transform: "matrix(.28091 -.17362 0 .28091 -2.582 5.597)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.7 3.068h.005V4.37l.027-.067Z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.447147,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(.18 .002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.444 4.169.56.318-.496.327-.61-.335Z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.981573,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(6.394 -2.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.906 3.632.563.316-1.424.839-.59-.34Zm.786.464.63.334-1.435.827-.59-.34Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: ".0410666px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1.015 -2.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.931 5.343 1.456-.832-.024 1.664-1.42.849Zm-.088 0-1.426-.814.024 1.622L2.86 7Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".0410666px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1.015 -2.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.03 4.856.203.115.002.448-.032-.056-.023.042-.024-.054-.032.043-.017-.054-.039.041-.017-.062-.028.058.005-.53",
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.00155212,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(1.015 -2.482)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "5.33333px",
      lineHeight: 0.65,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline"
    },
    transform: "translate(.292 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.057 14.227 3.466 1.728v.176l-.384-.176h-3.082zm0-.373 3.466 1.728v.187l-3.466-1.728zm0-.39 3.466 1.74v.191l-3.466-1.744zm0-.373 3.466 1.739v.187l-3.466-1.739zm0-.362 3.466 1.728v.186l-3.466-1.738zm0-.379 1.648.827v-.827h1.818v1.91l-3.466-1.723z",
    "aria-label": "N",
    style: {
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal",
      fill: "green"
    },
    transform: "matrix(.28091 -.17362 0 .28091 -1.998 3.337)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2.241 3.67 1.497.92m1.467-.898-1.467.898",
    style: {
      fill: "green",
      stroke: "green",
      strokeWidth: 0.0264581,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(.18 .002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.735 4.361.002.233",
    style: {
      fill: "green",
      stroke: "green",
      strokeWidth: 0.042333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#b)"
    },
    transform: "translate(.18 .002)"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMeusPedidos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meus_pedidos.a72b569c.svg";
export { ForwardRef as ReactComponent };